import { Helmet } from 'react-helmet';
import QuanlythenapDetail from 'src/components/quanlythenap-detail/QuanlythenapDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

const Quanlythenap = () => (
  <>
    <Helmet>
      <title>Quản lý thẻ nạp</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Box sx={{ pt: 3 }}>
          <QuanlythenapDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Quanlythenap;
